module.exports = __webpack_public_path__ + "static/pA7-01e25a488fb432634f0a30b7adc4b0ab.png";